import { unwrapResult } from '@reduxjs/toolkit'
import { Checkbox, Col, Modal, ModalProps, Row } from 'antd'
import _ from 'lodash'
import { ReactElement, useContext, useEffect, useState } from 'react'
import { useAppDispatch } from '../../app/hooks'
import { ThemeContext } from '../../theme/theme'
import { getSupervisorList } from './supervisorSlice'
import styles from './supervisor.module.css'

interface SupervisorSelectModalProps {
  mode?: 'checkbox' | 'radio'
  initialValue?: any[]
  onChange?: (value?: any[]) => void
}

export const SupervisorSelectModal = ({
  mode = 'checkbox',
  initialValue,
  onChange,
  visible,
  onCancel,
  onOk,
}: SupervisorSelectModalProps & ModalProps): ReactElement => {
  const dispatch = useAppDispatch()

  const theme = useContext(ThemeContext)

  const [supervisors, setSupervisors] = useState<any[]>([])

  const [selected, setSelected] = useState<any[]>([])

  useEffect(() => {
    if (visible) {
      dispatch(getSupervisorList())
        .then(unwrapResult)
        .then((data) => {
          setSupervisors(data || [])
        })
        .catch(() => {
          // do nothing.
        })
    }
  }, [dispatch, visible])

  useEffect(() => {
    if (initialValue) {
      if (mode === 'checkbox') {
        setSelected(initialValue)
      } else {
        setSelected(
          initialValue && initialValue.length > 0 ? [initialValue[0]] : []
        )
      }
    }
  }, [initialValue, mode])
  return (
    <Modal
      className={styles.model}
      width={960}
      centered
      title='勾选需要选择的卫健委(局)'
      visible={visible}
      onCancel={onCancel}
      onOk={(e) => {
        onChange && onChange(selected)
        onOk && onOk(e)
      }}
    >
      {supervisors.map((s, i) => {
        const all =
          s.regionOs.length === 0
            ? false
            : s.regionOs.reduce(
                (b: boolean, o: any) =>
                  b && !!selected.find((s) => s.osId === o.osId),
                true
              )
        const any =
          s.regionOs.length === 0
            ? false
            : s.regionOs.reduce(
                (b: boolean, o: any) =>
                  b || selected.find((s) => s.osId === o.osId),
                false
              )
        return (
          <Col
            key={s.regionCode}
            style={{ border: '1px solid #eee', marginTop: i ? 10 : 0 }}
          >
            <Row
              style={{
                height: '2.5rem',
                backgroundColor: theme.c3,
                padding: '0 15px',
              }}
              align='middle'
            >
              {mode === 'checkbox' ? (
                <Checkbox
                  style={{
                    color: theme.tc1,
                    fontWeight: 'bold',
                  }}
                  indeterminate={any && !all}
                  checked={all}
                  onChange={(v) => {
                    if (v.target.checked) {
                      setSelected(
                        _.chain(selected)
                          .concat(s.regionOs)
                          .uniqBy((o) => o.osId)
                          .value()
                      )
                    } else {
                      setSelected(
                        _.chain(selected)
                          .differenceBy(s.regionOs, (o) => o.osId)
                          .value()
                      )
                    }
                  }}
                >
                  {s.regionName}
                </Checkbox>
              ) : (
                <div style={{ color: theme.tc1, fontWeight: 'bold' }}>
                  {s.regionName}
                </div>
              )}
            </Row>
            <Row gutter={20} style={{ padding: '0 16px 20px 16px' }}>
              {s.regionOs.map((org: any) => (
                <>
                  <Col key={org.osId} flex='1 1 50%'>
                    <Checkbox
                      style={{ color: theme.tc1, marginTop: 20 }}
                      checked={!!selected.find((o) => o.osId === org.osId)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          if (mode === 'checkbox') {
                            setSelected(
                              _.chain(selected)
                                .concat(org)
                                .uniqBy((o) => o.osId)
                                .value()
                            )
                          } else {
                            setSelected([org])
                          }
                        } else {
                          if (mode === 'checkbox') {
                            setSelected(
                              selected.filter((o) => o.osId !== org.osId)
                            )
                          }
                        }
                      }}
                    >
                      {org.osName}
                    </Checkbox>
                  </Col>
                </>
              ))}
            </Row>
          </Col>
        )
      })}
    </Modal>
  )
}
